import { SchemaDefinition as BaseSchemaDefinition } from '../../models/SchemaDefinition'

import type { TypedSchema } from '../../types'

export class SchemaDefinition extends BaseSchemaDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'name',
      title: '字段名',
      type: 'Schema.String'
    },
    {
      name: 'deprecated',
      title: '是否废弃',
      type: 'Schema.Boolean'
    },
    {
      name: 'description',
      title: '字段描述',
      type: 'Schema.String'
    },
    {
      name: 'readOnly',
      title: '只读',
      type: 'Schema.Boolean'
    },
    {
      name: 'writeOnly',
      title: '只写',
      type: 'Schema.Boolean'
    },
    {
      name: 'fallback',
      title: '默认值',
      type: 'Schema.Any'
    },
    {
      name: 'nullable',
      title: '可选',
      type: 'Schema.Boolean'
    },
    {
      name: 'example',
      title: '示例值',
      type: 'Schema.String'
    },
    {
      name: 'required',
      title: '是否必填',
      type: 'Schema.Boolean'
    },
    {
      name: 'title',
      title: '标题',
      type: 'Schema.String'
    }
  ]
}
